import { clsxMerge } from "shared/lib/helpers";

import ExitGuardLogo from "@/components/modules/apply/exit-guard-logo";

/**
 * Sticky progress header used by the applicant funnel flow pages
 * (/apply/qualify, /apply/form). Renders the Glencoco wordmark on the
 * left, current step indicator on the right, and a thin progress bar
 * at the bottom.
 *
 * Kept intentionally separate from the marketing Layout so we don't
 * show the full nav (Pricing, Resources, Log in) inside a focused
 * application flow.
 */
interface FlowHeaderPropsI {
  step: number;
  total: number;
  label: string;
}

export default function FlowHeader({ step, total, label }: FlowHeaderPropsI) {
  const pct = Math.min(100, Math.max(0, (step / total) * 100));

  return (
    <header
      className={clsxMerge(
        "sticky top-0 z-40",
        "bg-white/90 backdrop-blur",
        "border-b border-base-200"
      )}
    >
      <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
        <ExitGuardLogo width="112px" />
        <div className="text-sm text-base-content/60">
          Step {step} of {total}{" "}
          <span className="hidden sm:inline">
            — <span className="font-medium text-base-content">{label}</span>
          </span>
        </div>
      </div>
      <div className="h-1 bg-base-200">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </header>
  );
}
